import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./Gallery.css";

// ✅ ALL IMAGE IMPORTS
import c1 from "../../Assets/SelfDrive/Tharr.jpg";
import c2 from "../../Assets/SelfDrive/Fortuner.jpg";
import c3 from "../../Assets/SelfDrive/Scorpio N.jpg";
import c4 from "../../Assets/SelfDrive/Safari.jpg";
import c5 from "../../Assets/SelfDrive/xuv700.jpg";
import c6 from "../../Assets/SelfDrive/Innova Crysta.jpg";
import c7 from "../../Assets/SelfDrive/Kia Seltos.jpg";
import c8 from "../../Assets/SelfDrive/Hyundai Creta.jpg";
import c9 from "../../Assets/SelfDrive/MG Hector.jpg";
import c10 from "../../Assets/SelfDrive/Toyota Hyryder.jpg";
import c11 from "../../Assets/SelfDrive/Ertiga CNG 2025.jpg";
import c12 from "../../Assets/SelfDrive/Verna Sunroof.jpg";
import c13 from "../../Assets/SelfDrive/Baleno 2025.jpg";
import c14 from "../../Assets/SelfDrive/Swift 2025.jpg";
import c15 from "../../Assets/SelfDrive/Honda City.jpg";
import c16 from "../../Assets/SelfDrive/i20 Sportz.jpg";
import c17 from "../../Assets/SelfDrive/Amaze.jpg";
import c18 from "../../Assets/SelfDrive/Dzire.jpg";
import c19 from "../../Assets/SelfDrive/Altroz.jpg";
import c20 from "../../Assets/SelfDrive/Ciaz.jpg";
import c21 from "../../Assets/SelfDrive/Audi A6.jpg";
import c22 from "../../Assets/SelfDrive/BMW 5 Series.jpg";
import c23 from "../../Assets/SelfDrive/Mercedes C-Class.jpg";
import c24 from "../../Assets/SelfDrive/Jaguar XF.jpg";
import c25 from "../../Assets/SelfDrive/Audi Q7.jpg";
import c26 from "../../Assets/SelfDrive/BMW X5.jpg";
import c27 from "../../Assets/SelfDrive/Mercedes E-Class.jpg";
import c28 from "../../Assets/SelfDrive/BMW 7 Series.jpg";
import c29 from "../../Assets/SelfDrive/Audi A4.jpg";
import c30 from "../../Assets/SelfDrive/Volvo XC90.jpg";
import c31 from "../../Assets/SelfDrive/Luxury Wedding Car.jpg";
import c32 from "../../Assets/SelfDrive/Bride & Groom Special.jpg";
import c33 from "../../Assets/SelfDrive/Full Day Wedding Package.jpg";
import c34 from "../../Assets/SelfDrive/VIP Event Car.jpg";
import c35 from "../../Assets/SelfDrive/Luxury Decorated Car.jpg";
import c36 from "../../Assets/SelfDrive/Barat Car Package.png";
import c37 from "../../Assets/SelfDrive/Wedding SUV Package.jpg";
import c38 from "../../Assets/SelfDrive/Luxury Convoy.jpg";
import c39 from "../../Assets/SelfDrive/Reception Entry Car.jpg";
import c40 from "../../Assets/SelfDrive/Corporate Event Package.jpg";

// ✅ CAR DATA ARRAY
const cars = [
  { src: c1, title: "Mahindra Thar 2025", price12: "₹3000", price24: "₹4500" },
  { src: c2, title: "Toyota Fortuner", price12: "₹8000", price24: "₹11000" },
  { src: c3, title: "Mahindra Scorpio N", price12: "₹3500", price24: "₹5000" },
  { src: c4, title: "Tata Safari", price12: "₹4000", price24: "₹6000" },
  { src: c5, title: "Mahindra XUV700", price12: "₹4500", price24: "₹6500" },
  { src: c6, title: "Toyota Innova Crysta", price12: "₹3000", price24: "₹4500" },
  { src: c7, title: "Kia Seltos", price12: "₹3000", price24: "₹4500" },
  { src: c8, title: "Hyundai Creta 2025", price12: "₹3500", price24: "₹5000" },
  { src: c9, title: "MG Hector", price12: "₹3500", price24: "₹5000" },
  { src: c10, title: "Toyota Hyryder", price12: "₹3000", price24: "₹4500" },
  { src: c11, title: "Ertiga CNG 2025", price12: "₹2200", price24: "₹3000" },
  { src: c12, title: "Verna Sunroof", price12: "₹3500", price24: "₹4500" },
  { src: c13, title: "Baleno Petrol", price12: "₹1500", price24: "₹2000" },
  { src: c14, title: "Swift 2025", price12: "₹1500", price24: "₹2500" },
  { src: c15, title: "Honda City", price12: "₹3000", price24: "₹4000" },
  { src: c16, title: "i20 Sportz", price12: "₹2000", price24: "₹3000" },
  { src: c17, title: "Honda Amaze", price12: "₹1800", price24: "₹2500" },
  { src: c18, title: "Dzire CNG", price12: "₹1500", price24: "₹2500" },
  { src: c19, title: "Tata Altroz", price12: "₹2000", price24: "₹3000" },
  { src: c20, title: "Ciaz", price12: "₹2500", price24: "₹3500" },
  { src: c21, title: "Audi A6", price12: "₹12000", price24: "₹18000" },
  { src: c22, title: "BMW 5 Series", price12: "₹12000", price24: "₹18000" },
  { src: c23, title: "Mercedes C-Class", price12: "₹11000", price24: "₹17000" },
  { src: c24, title: "Jaguar XF", price12: "₹13000", price24: "₹19000" },
  { src: c25, title: "Audi Q7", price12: "₹15000", price24: "₹22000" },
  { src: c26, title: "BMW X5", price12: "₹15000", price24: "₹22000" },
  { src: c27, title: "Mercedes E-Class", price12: "₹12000", price24: "₹18000" },
  { src: c28, title: "BMW 7 Series", price12: "₹20000", price24: "₹30000" },
  { src: c29, title: "Audi A4", price12: "₹10000", price24: "₹15000" },
  { src: c30, title: "Volvo XC90", price12: "₹16000", price24: "₹24000" },
  { src: c31, title: "Luxury Wedding Car", price12: "₹10000", price24: "₹15000" },
  { src: c32, title: "Bride & Groom Special", price12: "₹12000", price24: "₹18000" },
  { src: c33, title: "Full Day Wedding Package", price12: "₹15000", price24: "₹25000" },
  { src: c34, title: "VIP Event Car", price12: "₹8000", price24: "₹12000" },
  { src: c35, title: "Luxury Decorated Car", price12: "₹10000", price24: "₹15000" },
  { src: c36, title: "Baraat Car Package", price12: "₹12000", price24: "₹20000" },
  { src: c37, title: "Wedding SUV Package", price12: "₹8000", price24: "₹12000" },
  { src: c38, title: "Luxury Convoy", price12: "₹20000", price24: "₹30000" },
  { src: c39, title: "Reception Entry Car", price12: "₹9000", price24: "₹14000" },
  { src: c40, title: "Corporate Event Package", price12: "₹7000", price24: "₹12000" }
];

const Gallery = () => {
  const [selectedCar, setSelectedCar] = useState(null);
  const phoneNumber = "919755357721";

  const handleWhatsApp = (e, car) => {
    e.stopPropagation(); // Prevents opening the lightbox when clicking the button
    const message = `Hello Shree Ram Car Rental, I'm interested in booking:
🚗 *Vehicle:* ${car.title}
💰 *12h Rate:* ${car.price12}
💰 *24h Rate:* ${car.price24}

Please let me know the availability.`;

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <>
      <Helmet>
        <title>Our Fleet Gallery | Shree Ram Car Rental Indore</title>
        <meta
          name="description"
          content="View our premium fleet of 40+ self-drive and luxury cars in Indore. Thar, Fortuner, Audi, and BMW available for rent."
        />
      </Helmet>

      <section className="gallery-section">
        <div className="gallery-header">
          <h1>Our <span>Premium</span> Fleet</h1>
          <p>Indore's largest collection of self-drive & luxury cars</p>
        </div>

        <div className="gallery-grid">
          {cars.map((car, index) => (
            <div
              className="gallery-card"
              key={index}
              onClick={() => setSelectedCar(car)}
            >
              <div className="image-container">
                <img 
                  src={car.src} 
                  alt={`${car.title} car rental Indore`} 
                  loading="lazy" 
                />
              </div>

              <div className="card-info">
                <h3>{car.title}</h3>
                <p className="price-text">
                  12h: <b>{car.price12}</b> | 24h: <b>{car.price24}</b>
                </p>
                <button
                  className="whatsapp-btn"
                  onClick={(e) => handleWhatsApp(e, car)}
                >
                  💬 Book Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* LIGHTBOX MODAL */}
        {selectedCar && (
          <div className="lightbox" onClick={() => setSelectedCar(null)}>
            <div
              className="lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              <span className="close-lightbox" onClick={() => setSelectedCar(null)}>&times;</span>
              <img src={selectedCar.src} alt={selectedCar.title} />
              <div className="lightbox-details">
                <h2>{selectedCar.title}</h2>
                <div className="lightbox-pricing">
                   <div className="price-box">
                      <span>12 Hours</span>
                      <strong>{selectedCar.price12}</strong>
                   </div>
                   <div className="price-box">
                      <span>24 Hours</span>
                      <strong>{selectedCar.price24}</strong>
                   </div>
                </div>
                <button
                  className="whatsapp-btn-large"
                  onClick={(e) => handleWhatsApp(e, selectedCar)}
                >
                  💬 Book on WhatsApp
                </button>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Gallery;